var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4008 4.19844H7.20078C6.87078 4.19844 6.60078 4.46844 6.60078 4.79844V19.1984C6.60078 19.5284 6.87078 19.7984 7.20078 19.7984H16.8008C17.1308 19.7984 17.4008 19.5284 17.4008 19.1984V10.1984H14.1008C12.6083 10.1984 11.4008 8.99094 11.4008 7.49844V4.19844ZM16.6545 8.39844L13.2008 4.94469V7.49844C13.2008 7.99719 13.602 8.39844 14.1008 8.39844H16.6545ZM4.80078 4.79844C4.80078 3.47469 5.87703 2.39844 7.20078 2.39844H12.207C12.8445 2.39844 13.4558 2.64969 13.9058 3.09969L18.4995 7.69719C18.9495 8.14719 19.2008 8.75844 19.2008 9.39594V19.1984C19.2008 20.5222 18.1245 21.5984 16.8008 21.5984H7.20078C5.87703 21.5984 4.80078 20.5222 4.80078 19.1984V4.79844Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.cefa2b1e3fb8baa89ee2b40e71dab3a6.svg";
export { ForwardRef as ReactComponent };